import axios from 'axios';
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import * as Yup from "yup";
import Cookies from "js-cookie";
import { useNavigate } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Table } from "antd";
import { adminMainUrl } from '../../../../Config';
import InputTextJSX from './InputTextJSX';

const AirlineAdd = ({ accessedPermission }) => {
    const navigate = useNavigate();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const [activeTab, setActiveTab] = useState("airline_master");

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');

    useEffect(() => {
        if (token && user_id) {
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token]);

    const initialValues = {
        name: "",
        international_code: "",
        international_awb_perfix: "",
        international_awb_format: "",
        domestic_code: "",
        domestic_awb_perfix: "",
        domestic_awb_format: "",
        is_iata: false,
        pan_number: "",
        pima_code: "",
        account_number: "",
        commission_type: "",
        commission_rate: "",
        two_digit_code: "",
        three_digit_code: "",
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({
            // name: Yup.string().required("Please enter name")
        }),
        onSubmit: (values, { resetForm }) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }
                axios.post(`${adminMainUrl}/api/master/airline/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            resetForm();
                            // console.log(response.data)
                            navigate(`/flexichain/airline/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    const columns = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "Default", dataIndex: "is_default", key: "is_default" },
        { title: "Address 1", dataIndex: "address_one", key: "address_one" },
        { title: "Address 2", dataIndex: "address_two", key: "address_two" },
        { title: "City", dataIndex: "city", key: "city" },
        { title: "State", dataIndex: "state", key: "state" },
        { title: "Country", dataIndex: "country", key: "country" },
        { title: "Pin Code", dataIndex: "pincode", key: "pincode" },
        // { title: "Contact Person", dataIndex: "contact_person_name", key: "contact_person_name" },
        // { title: "Mobile No.", dataIndex: "mobile_no", key: "mobile_no" },
        // { title: "GST State Name", dataIndex: "gst_state_name", key: "gst_state_name" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];
    const [dataSource, setDataSourcer] = useState(false);

    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <h4>Add Airline</h4>
                    </div>
                    <div className="row-gap-2">
                        <div className="tab-content" id="pills-tabContent">
                            <Tabs
                                activeKey={activeTab} // Controlled by state
                                onSelect={(k) => setActiveTab(k)} // Update state on tab change
                                transition={false}
                                id="noanim-tab-example"
                                className="nav nav-pills mb-3 custom-tabs gap-0"
                            >
                                <Tab eventKey="airline_master" title="Airline Master" className="nav-item" disabled={false}>
                                    <div className="card">
                                        <div className="card-body">
                                            {/* Filter */}
                                            <form onSubmit={formik.handleSubmit}>
                                                <div className="row">
                                                    <InputTextJSX
                                                        labelText={"Airline Name"}
                                                        nameValue={"name"}
                                                        value={formik.values.name}
                                                        onChange={formik.handleChange}
                                                        maxLength={100}
                                                    />
                                                    <div className={`col-md-6 mt-2`}>
                                                        <div className='ms-2'>
                                                            <label htmlFor="" className='form-label  mb-0'>
                                                                3 Digit Code
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <input
                                                                    type="text"
                                                                    maxLength={3}
                                                                    className="form-control form-control-sm"
                                                                    id={"three_digit_code"}
                                                                    name={"three_digit_code"}
                                                                    value={formik.values.three_digit_code}
                                                                    onChange={formik.handleChange}
                                                                    onInput={(event) => {
                                                                        let value = event.target.value;
                                                                        value = value.replace(/[^0-9]/g, '');
                                                                        event.target.value = value;
                                                                    }}

                                                                // onBlur={formik.handleBlur}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`col-md-6 mt-2`}>
                                                        <div className='ms-2'>
                                                            <label htmlFor="" className='form-label  mb-0'>
                                                                2 Digit Code
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <input
                                                                    type="text"
                                                                    maxLength={2}
                                                                    className="form-control form-control-sm"
                                                                    id={"two_digit_code"}
                                                                    name={"two_digit_code"}
                                                                    value={formik.values.two_digit_code}
                                                                    onChange={formik.handleChange}
                                                                    // onInput={(event) => {
                                                                    //     let value = event.target.value;
                                                                    //     value = value.replace(/[^0-9]/g, '');
                                                                    //     event.target.value = value;
                                                                    // }}

                                                                // onBlur={formik.handleBlur}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`col-md-6 mt-2`}>
                                                        <div className='ms-2'>
                                                            <label htmlFor="" className='form-label  mb-0'>
                                                                Commission Rate
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <input
                                                                    type="text"
                                                                    maxLength={10}
                                                                    className="form-control form-control-sm"
                                                                    id={"commission_rate"}
                                                                    name={"commission_rate"}
                                                                    value={formik.values.commission_rate}
                                                                    onChange={formik.handleChange}
                                                                    onInput={(event) => {
                                                                        let value = event.target.value;
                                                                        value = value.replace(/[^0-9]/g, '');
                                                                        event.target.value = value;
                                                                    }}
                                                                // onBlur={formik.handleBlur}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`col-md-6 mt-2`}>
                                                        <div className='ms-2'>
                                                            <label htmlFor="" className='form-label  mb-0'>
                                                                Comission Type
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <select
                                                                    className="form-control form-control-sm"
                                                                    id={"commission_type"}
                                                                    name={"commission_type"}
                                                                    value={formik.values.commission_type}
                                                                    onChange={formik.handleChange}
                                                                >
                                                                    <option value="">-Select an option-</option>
                                                                    <option value="NET">Net</option>
                                                                    <option value="GROSS">Gross</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <InputTextJSX
                                                        labelText={"Account No."}
                                                        nameValue={"account_number"}
                                                        value={formik.values.account_number}
                                                        onChange={formik.handleChange}
                                                        maxLength={20}
                                                    />
                                                    <InputTextJSX
                                                        labelText={"Airline Pima Code"}
                                                        nameValue={"pima_code"}
                                                        value={formik.values.pima_code}
                                                        onChange={formik.handleChange}
                                                        maxLength={35}
                                                    />
                                                    <InputTextJSX
                                                        labelText={"Pan No."}
                                                        nameValue={"pan_number"}
                                                        value={formik.values.pan_number}
                                                        onChange={formik.handleChange}
                                                        maxLength={10}
                                                    />
                                                    <InputTextJSX
                                                        labelText={"International Code"}
                                                        nameValue={"international_code"}
                                                        value={formik.values.international_code}
                                                        onChange={formik.handleChange}
                                                        maxLength={10}
                                                    />
                                                    <InputTextJSX
                                                        labelText={"International AWB Prefix"}
                                                        nameValue={"international_awb_perfix"}
                                                        value={formik.values.international_awb_perfix}
                                                        onChange={formik.handleChange}
                                                        maxLength={10}

                                                    />
                                                    <InputTextJSX
                                                        labelText={"International AWB Format"}
                                                        nameValue={"international_awb_format"}
                                                        value={formik.values.international_awb_format}
                                                        onChange={formik.handleChange}
                                                        maxLength={10}

                                                    />
                                                    <InputTextJSX
                                                        labelText={"Domestic Code"}
                                                        nameValue={"domestic_code"}
                                                        value={formik.values.domestic_code}
                                                        onChange={formik.handleChange}
                                                        maxLength={10}

                                                    />
                                                    <InputTextJSX
                                                        labelText={"Domestic AWB Prefix"}
                                                        nameValue={"domestic_awb_perfix"}
                                                        value={formik.values.domestic_awb_perfix}
                                                        onChange={formik.handleChange}
                                                        maxLength={10}

                                                    />
                                                    <InputTextJSX labelText={"Domestic AWB Format"}
                                                        nameValue={"domestic_awb_format"}
                                                        value={formik.values.domestic_awb_format}
                                                        onChange={formik.handleChange}
                                                        maxLength={10}

                                                    />

                                                    <div className={`col-md-6 mt-2 d-flex align-items-center`}>
                                                        <div className='ms-2'>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                <input
                                                                    type="checkbox"
                                                                    className="me-2"
                                                                    id="is_iata"
                                                                    name="is_iata"
                                                                    checked={formik.values.is_iata}
                                                                    onChange={(e) => {
                                                                        formik.setFieldValue("is_iata", e.target.checked);
                                                                    }}
                                                                />
                                                                <label htmlFor="" className='form-label  mb-0'>
                                                                    IATA
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row d-flex justify-content-end mt-2">
                                                        <div className="col-md-6 d-flex justify-content-end">
                                                            <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                                                {
                                                                    disableSubmit ?
                                                                        <>
                                                                            <i className="fas fa-spinner fa-spin"></i> Saving...
                                                                        </>
                                                                        :
                                                                        "Add"
                                                                }
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className='card-body'>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <h4>Address</h4>
                                                </div>
                                                <div className="col-md-6 text-end">
                                                    <button type='button' className="btn btn-sm btn-primary" title="Add Airline details to save address." onClick={() => { toast.error("Add Airline details to save address.") }}>
                                                        + Add Address
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="table-responsive custom-table query-list-table">
                                                <Table className="table datanew dataTable no-footer"
                                                    dataSource={dataSource}
                                                    columns={columns}
                                                    pagination={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Tab>
                                {/* <Tab eventKey="contact_details" title="Contact Details" className="nav-item" disabled={true} >
                                    <CustomsTab token={token} user_id={user_id} />
                                </Tab> */}
                            </Tabs>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default AirlineAdd